// src/App.js
import React from "react";
import PrintBarcode from "./PrintBarcode";
import Zicorp from "./Zicorp.png";

function App() {
  return (
    <div className="App">
      <div
        style={{
          float: "right",
          padding: "10px", // Optional padding
        }}
      >
        <img
          src={Zicorp}
          alt="Company Logo"
          style={{ maxWidth: "100px", height: "auto" }}
        />
      </div>
      <h1>Barcode Label Printer</h1>
      <PrintBarcode />
    </div>
  );
}

export default App;
